interface JumpLinkItemProps {
  id: string;
  text: string;
  isActive: boolean;
  indent: number;
  scaledTextPadding: number;
  scaledFontSize: number;
  trackStyle: React.CSSProperties;
  onClick: () => void;
}

export const JumpLinkItem = ({
  id,
  text,
  isActive,
  indent,
  scaledTextPadding,
  scaledFontSize,
  trackStyle,
  onClick,
}: JumpLinkItemProps) => (
  <button data-jump-link-id={id} onClick={onClick} className="relative flex items-stretch text-left">
    {/* Active indicator that overlays the gray track when active */}
    <div
      className={`absolute top-0 bottom-0 w-1 transition-colors ${isActive ? 'bg-primary' : 'bg-transparent'}`}
      style={trackStyle}
    />
    {/* Text with indent */}
    <span
      className={`font-base text-dark py-1 leading-[1.4] ${isActive ? 'font-medium' : 'font-normal'}`}
      style={{
        paddingLeft: `${scaledTextPadding + indent}px`,
        fontSize: `${scaledFontSize}px`,
      }}
    >
      {text}
    </span>
  </button>
);
